import React, { useEffect, useState } from 'react';
import {
  SEARCH_CUSTOMER_BY_NUMBER,
  GET_CUSTOMER_TYPE_DOMAIN,
  INTERMEDIARY_LIST,
  LOOKUP_FIELDUSER,
  VIEW_PROPOSAL_FIRESF,
  DOCUMENT_STATIC_DATA,
} from './queries';
import { useQuery } from '@apollo/client';
//import useFetchQuery from '../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import Loading from '../../../lib/layout/loading';
// import Error from '../../../lib/layout/error';
import { Loading, Error } from 'quanta-flows/modules/layout';
//import { ClientService, Layout } from '../../../lib/layout';
import { ClientService ,Layout} from 'quanta-flows/modules/layout';
import { Card, useResponsiveParams, Text } from 'quanta-ui';
//import { updateBuyFirePolicyVar } from '../new-policy-issuance/fire/_graphql/state';
import { updateBuyFirePolicyVar } from 'quanta-flows/modules/proposal/fire/state';
//import { updateFireQuoteUploadDocsVar } from '../capture-details/fire/_graphql/state';

import { updateFireQuoteUploadDocsVar } from 'quanta-flows/modules/quote/fire/state';
//import NewFirePolicyIssuance from '../new-policy-issuance/fire';
import NewFirePolicyIssuanceSA from '../new-policy-issuance/fire/Standalone Fire';
export default function viewProposalFire({
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
}) {
  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : searchText === null || searchText === undefined
      ? ''
      : `${searchText}`;
  };

  const fetchQuery = useFetchQuery();

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const {
    loading: loadingCustomerDetails,
    error: errorCustomerDetails,
    data: dataCustomerDetails,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        customer_type: 'Individual',
        customer_number: customerID,
      },
    },
  });
  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST, {
    fetchPolicy: 'cache-first',
  });

  const { loading, error, data } = useQuery(VIEW_PROPOSAL_FIRESF, {
    variables: {
      input: {
        productCode: productCode,
        customerID: customerID,
        proposalNumber: proposalNumber,
      },
    },
  });
if (data) {
    var { viewProposalSF } = data;
    var { finalisedPremium, financierDtls } = viewProposalSF; 
  }
  useEffect(() => {
    const fetchViewProposalData = async () => {
      if (
        data &&
        data?.viewProposalSF &&
        dataCustomerDetails &&
        dataDocumentExtensions &&
        dataMyIntermediaries
      ) {
        try {
          if (
            customerID?.toString()?.toLowerCase() ===
            data?.viewProposalSF?.customerID
              ?.toString()
              ?.toLowerCase()
          ) {
            const customer = dataCustomerDetails?.customer;
            let getCustomerDomain = fetchQuery({
              query: GET_CUSTOMER_TYPE_DOMAIN,
            });
            let {
              data: customerDomainData,
            } = await getCustomerDomain;

            if (
              data?.viewProposalSF?.intermediaryDetails
                ?.fieldUserCode
            ) {
              var associatedEntityLookupQuery = fetchQuery({
                query: LOOKUP_FIELDUSER,
                variables: {
                  filter: {
                    fieldUserID: data?.viewProposalSF
                      ?.intermediaryDetails?.fieldUserCode
                      ? `${data?.viewProposalSF?.intermediaryDetails?.fieldUserCode}`
                      : '',
                  },
                },
              });
              var {
                data: associatedEntityLookupData,
              } = await associatedEntityLookupQuery;
            }

            const { customerTypeList } = customerDomainData;
            const { myIntermediaries } = dataMyIntermediaries;
            const associatedEntityLookup =
              associatedEntityLookupData?.associatedEntityLookup;

            const plan = [
              {
                name: data?.viewProposalSF?.plan?.name,
                code: data?.viewProposalSF?.plan?.name,
                subPlan: data?.viewProposalSF?.plan?.subPlan?.name,
                subPlanCode:
                  data?.viewProposalSF?.plan?.subPlan?.code,
                tenureCode:
                  data?.viewProposalSF?.plan?.subPlan?.tenure?.code,
                tenure:
                  data?.viewProposalSF?.plan?.subPlan?.tenure
                    ?.value,
              },
            ];

            const getIntermediaryName = (code) => {
              return myIntermediaries
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode === code,
                  )?.intermediaryName
                : code;
            };

            const getBusinessLocation = (
              intermediarycode,
              locationCode,
            ) => {
              return myIntermediaries &&
                intermediarycode &&
                locationCode
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode ===
                      intermediarycode,
                  )
                  ? myIntermediaries
                      ?.find(
                        (intermediary) =>
                          intermediary?.intermediaryCode ===
                          intermediarycode,
                      )
                      ?.businessLocations.find(
                        (location) => location?.code === locationCode,
                      )?.name
                  : locationCode
                : '';
            };
            updateFireQuoteUploadDocsVar({
              documentDetails: viewProposalSF?.uploadedDocuments?.map(
                (fireData) => {
                  return {
                    documentDescription: '',
                    documentName: fireData?.documentType?.code
                      ? `${fireData?.documentType?.code}`
                      : '',
                    documentNameValue: fireData?.documentType?.value
                      ? `${fireData?.documentType?.value}`
                      : '',
                    documentFileName: fireData?.documentName
                      ? `${fireData?.documentName?.split('.')[0]}`
                      : '',
                    documentFileNameWithExtension: fireData?.documentName
                      ? `${fireData?.documentName}`
                      : '',
                    documentExtension: dataDocumentExtensions?.documentExtensions?.find(
                      (extension) =>
                        extension?.value
                          ?.toString()
                          ?.toLowerCase() ===
                        fireData?.documentName
                          ?.split('.')
                          .pop()
                          ?.toString()
                          ?.toLowerCase(),
                    )?.code,
                    documentSize: parseFloat(
                      parseFloat(fireData?.documentSize)?.toFixed(2),
                    ),
                    documentSizeinKB: fireData?.documentSize
                      ? `${fireData?.documentSize}`
                      : '',
                    documentBase64String: fireData?.base64EncodedDoc
                      ? `${fireData?.base64EncodedDoc}`
                      : '',
                  };
                },
              ),
            });
            
            updateBuyFirePolicyVar({
              
              customerFetchRequiredOnLoad: false,
              policyTypeValue : data?.viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
              intermediary: {
                code: data?.viewProposalSF?.intermediaryDetails?.code,
                intermediaryName: getIntermediaryName(
                  data?.viewProposalSF?.intermediaryDetails?.code,
                ),
                branchOfficeName: getBusinessLocation(
                  data?.viewProposalSF?.intermediaryDetails?.code,
                  data?.viewProposalSF?.intermediaryDetails
                    ?.location,
                ),
                branchOfficeCode:
                  data?.viewProposalSF?.intermediaryDetails
                    ?.location,
                fieldUserCode: '00012',
                fieldUserName: associatedEntityLookup?.fieldUserName
                  ? `${associatedEntityLookup?.fieldUserName}`
                  : '',
              },
              isQuoteSaved: true,
              quoteData: {
                tabDetails: {
                  additionalTabDetails: {
                    clauses: {
                      userDefinedClauses: viewProposalSF?.clauses
                        ?.userDefined
                        ? viewProposalSF?.clauses?.userDefined
                        : null,
                    },
                    conditions: {
                      userDefinedConditions: viewProposalSF
                        ?.conditions?.userDefined
                        ? viewProposalSF?.conditions?.userDefined
                        : null,
                    },
                    exclusions: {
                      userDefinedExclusions: viewProposalSF
                        ?.exclusions?.userDefined
                        ? viewProposalSF?.exclusions?.userDefined
                        : null,
                    },
                    warranties: {
                      userDefinedWarranties: viewProposalSF
                        ?.warranties?.userDefined
                        ? viewProposalSF?.warranties?.userDefined
                        : null,
                    },
                  },
                  riskLocationTabDetails: {
                    floaterType:
                      data?.viewProposalSF?.policyType
                        ?.toString()
                        ?.toLowerCase() === 'floater'
                        ? {
                            occupancy: {
                              code:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.code,
                              value:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.value,
                              occupancySection:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue
                                  ?.occupancySection,
                              occupancyRate:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.occupancyRate,
                              riskCode:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.riskCode,
                              rateCode:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.rateCode,
                              riskGrade:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.riskGrade,
                              riskGradeDefinition:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue
                                  ?.riskGradeDefinition,
                              riskPreference:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue
                                  ?.riskPreference,
                              gicClass:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.gicClass,
                              stfiRate:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.stfiRate,
                              rsmdRate:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.occupancyCodeValue?.rsmdRate,
                            },
                            riskLocationID:
                              data?.viewProposalSF?.riskLocations[0]
                                ?.riskLocationID,
                            floaterLocations: data?.viewProposalSF?.riskLocations[0]?.floaterLocations?.map(
                              (riskLoc) => {
                                return {
                                  pinCode: riskLoc?.address_line1,
                                  state: riskLoc?.state,
                                  city: riskLoc?.city,
                                  district: riskLoc?.district,
                                  eqZone: riskLoc?.eqZone,
                                  addressLine1:
                                    riskLoc?.address_line1,
                                  locationCode: riskLoc?.locationCode,
                                  showEdit: false,
                                };
                              },
                            ),
                            riskSumInsured: {
                              stocksSI:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.stockSI,
                              stocksInProcessSI:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.stocksInProcessSI,
                              stocksOnFloaterBasis:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.stockOnFloaterBasis=== true ? 'Yes' : 'No',
                              maximumStockSIAtOneLocation:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.maxStockSIAtOneLoc,
                            },
                            fireExtinguisherAppliancesDetails: data?.viewProposalSF?.riskLocations[0]?.fireExtinguishApplisDtls?.map(
                              (fireData) => {
                                return {
                                  label: fireData?.applianceValue,
                                  value: fireData?.applianceCode,
                                  selected:
                                    fireData?.isSelected === true
                                      ? true
                                      : false,
                                };
                              },
                            ),
                            otherDetails: {
                              classOfConstruction:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.constructionClass,
                              distanceFromWaterbody:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.waterbodyDistance,
                              securityProvisions:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.securityProvisions,
                            },
                            loadingAndDiscount: {
                              discountPercentage:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.discountPct,
                              loadingPercentage:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.loadingPct,
                            },
                            previousClaimDetails: {
                              claimExperience:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.prevClaimExpDesc,
                            },
                            locationPremium: {
                              locationNetPremium:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.premium?.locationNetPremium,
                              locationGST:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.premium?.locationGST,
                              locationTotalPremium:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.premium?.locationTotalPremium,
                              stampDuty:
                                data?.viewProposalSF?.riskLocations[0]
                                  ?.premium?.stampDuty,
                            },
                          }
                        : {
                            occupancy: {
                              code: '',
                              value: '',
                              occupancySection: '',
                              occupancyRate: '',
                              riskCode: '',
                              rateCode: '',
                              riskGrade: '',
                              riskGradeDefinition: '',
                              riskPreference: '',
                              gicClass: '',
                              stfiRate: '',
                              rsmdRate: '',
                            },
                            riskLocationID: '',
                            floaterLocations: [],
                            riskSumInsured: {
                              stocksSI: '',
                              stocksInProcessSI: '',
                              stocksOnFloaterBasis: '',
                              maximumStockSIAtOneLocation: '',
                            },
                            fireExtinguisherAppliancesDetails: [],
                            otherDetails: {
                              classOfConstruction: '',
                              distanceFromWaterbody: '',
                              securityProvisions: '',
                            },
                            loadingAndDiscount: {
                              discountPercentage: '',
                              loadingPercentage: '',
                            },
                            previousClaimDetails: {
                              claimExperience: '',
                            },
                            locationPremium: {
                              locationNetPremium: '',
                              locationGST: '',
                              locationTotalPremium: '',
                              stampDuty: '',
                            },
                          },
                    nonFloaterType:
                      
                        {
                                riskLocationID:
                                  '',
                                isDeleted: false,
                                occupancy: {
                                  code: data?.viewProposalSF
                                    ?.ThirdGrid_Details?.Occupancy_Name
                                    ?.occupancyCodeValue?.code
                                    ? `${data?.viewProposalSF?.ThirdGrid_Details?.Occupancy_Name}`
                                    : '',
                                  value: data?.viewProposalSF?.ThirdGrid_Details?.Occupancy_Name
                                  ? `${data?.viewProposalSF?.ThirdGrid_Details?.Occupancy_Name}`
                                  : '',
                                  occupancySection:  data?.viewProposalSF?.ThirdGrid_Details?.Occupancy_Name,
                                  occupancyRate:'',
                                  riskCode: '',
                                  rateCode: '',
                                  riskGrade: '',
                                  riskGradeDefinition: '',
                                  riskPreference: '',
                                  gicClass: '',
                                  stfiRate: '',
                                  rsmdRate: '',
                                },
                                isLocationSaved: true,
                                riskSumInsured: {
                                  additionalStructure: data?.viewProposalSF?.ThirdGrid_Details?.Additional_Structure,
                                  buildingValue: data?.viewProposalSF?.ThirdGrid_Details?.Building_Value,
                                  carpetArea: data?.viewProposalSF?.ThirdGrid_Details?.Carpet_Area,
                                  costOfConstruction: data?.viewProposalSF?.ThirdGrid_Details?.Cost_Of_Construction,
                                  totalBuildingSI: data?.viewProposalSF?.ThirdGrid_Details?.TotalBuilding_Sum_Insured,
                                  GeneralContentSI : data?.viewProposalSF?.ThirdGrid_Details?.GeneralContentSI,
                                  ValuableContentSI: data?.viewProposalSF?.ThirdGrid_Details?.ValuableContentSI,
                                  TotalContentSI: data?.viewProposalSF?.ThirdGrid_Details?.TotalContentSI,
                                },
                                stock: {
                                  stocksSI:'',
                                  stocksInProcessSI:'',
                                  stocksOnFloaterBasis:'',
                                  maximumStockSIAtOneLocation:'',
                                },
                                locationSumInsured:'',
                                fireExtinguisherAppliancesDetails: '',
                                otherDetails: {
                                  classOfConstruction:'',
                                  distanceFromWaterbody:'',
                                  securityProvisions: '',
                                },
                                loadingAndDiscount: {
                                  discountPercentage:'',
                                  loadingPercentage:'',
                                },
                                locationPremium: {
                                  locationNetPremium:'',
                                  locationGST:'',
                                  locationTotalPremium:'',
                                  stampDuty:'',
                                },
                                previousClaimDetails: {
                                  claimExperience:'',
                                },
                                addressDetails: {
                                  addressLine1:  '',
                                  pincode: '',
                                  state: '',
                                  eqZone: '',
                                  district: '',
                                  isSamePremise: '',
                                  locationCode: '',
                                  locationDesc: '',
                                },
                                stockLocations:
                                  '',
                              },
                            
                          
                        
                  },
                  customerTabDetails: {
                    policyTypeDetails: {
                      isInsuranceForKutchaConstruction:
                        data?.viewProposalSF?.isKutchaConstruct ===
                        true
                          ? 'Yes'
                          : 'No',
                      policyOrCoverType: {
                        code: data?.viewProposalSF?.policyType
                          ? `${data?.viewProposalSF?.policyType}`
                          : '',
                        value: data?.viewProposalSF?.policyType
                          ? `${data?.viewProposalSF?.policyType}`
                          : '',
                      },
                      tenure: {
                        code: data?.viewProposalSF?.tenure?.code
                          ? data?.viewProposalSF?.tenure?.code
                          : '',
                        value: data?.viewProposalSF?.tenure?.value
                          ? data?.viewProposalSF?.tenure?.value
                          : '',
                      },
                    },
                  },
                },
                finalisedPremium: {
                  locationNetPremium: finalisedPremium?.locNetPremium
                    ? finalisedPremium?.locNetPremium
                    : '',
                  locationGST: finalisedPremium?.locGST
                    ? finalisedPremium?.locGST
                    : '',
                  locationTotalPremium: finalisedPremium?.locTotalPremium
                    ? finalisedPremium?.locTotalPremium
                    : '',
                  stampDuty: finalisedPremium?.stampDuty
                    ? finalisedPremium?.stampDuty
                    : '',
                },
                documentDetails: data?.viewProposalSF
                  ?.uploadedDocuments
                  ? data?.viewProposalSF?.uploadedDocuments
                  : null,
              },

              quoteNumber: reformData(
                data?.viewProposalSF?.quoteNumber,
                '',
              ),
              quoteStatus: '',
              quotationType: '',
              financierDetails: {
                getFinancerDetails: financierDtls ? 'Yes' : 'No',
                financerName: financierDtls?.financerName
                  ? financierDtls?.financerName
                  : null,
                financerAddress: financierDtls?.financerAddress
                  ? financierDtls?.financerAddress
                  : null,
                financerAgreementType: financierDtls?.financerAgreementType
                  ? financierDtls?.financerAgreementType
                  : null,
                loanAccountNumber: financierDtls?.loanAccountNumber
                  ? financierDtls?.loanAccountNumber
                  : null,
                fileNumber: financierDtls?.fileNumber
                  ? financierDtls?.fileNumber
                  : null,
              },

              premiumData: {
                discount: [],
                loading: [],
                netPremium: finalisedPremium?.locNetPremium
                  ? parseFloat(finalisedPremium?.locNetPremium)
                  : null,
                stampDuty: finalisedPremium?.stampDuty
                  ? parseFloat(finalisedPremium?.stampDuty)
                  : null,
                gst: finalisedPremium?.locGST
                  ? parseFloat(finalisedPremium?.locGST)
                  : null,
                totalPremium: finalisedPremium?.locTotalPremium
                  ? parseFloat(finalisedPremium?.locTotalPremium)
                  : null,
              },

              policyStartDate: reformData(
                data?.viewProposalSF?.policyStartDate,
                '',
              ),
              policyTenure: reformData(
                data?.viewProposalSF?.policyTenure,
                '',
              ),
              quoteCreationDate: '',
              proposalNumber: data?.viewProposalSF?.proposalNumber,
              proposalStatus: data?.viewProposalSF?.proposalStatus,
              proposalPaymentType: (data?.viewProposalSF?.quoteNumber === 'NA' 
                  || data?.viewProposalSF?.quoteNumber === null )
                ? 'EPROPOSAL'
                : data?.viewProposalSF?.Proposal_Payment_Type?.toUpperCase(),//'EPROPOSAL',
              isProposalApplicableForPayment:
	      data?.viewProposalSF?.IsApplicableForPayment,
              isPolicyIssued: false,

              businessOfInsured:
                data?.viewProposalSF?.businessOfInsured,
              industryCategory:
                data?.viewProposalSF?.industryCategory?.code,
              industryCategoryValue:
                data?.viewProposalSF?.industryCategory?.value,
              industrySubCategory:
                data?.viewProposalSF?.industrySubCategory?.code,
              industrySubCategoryValue:
                data?.viewProposalSF?.industrySubCategory?.value,
              policyType: data?.viewProposalSF?.policyType,
              policyTypeValue: data?.viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
              locationType:
                data?.viewProposalSF?.locationType?.code,
              locationTypeValue:
                data?.viewProposalSF?.locationType?.value,
              allIndiaBasisDescription:
                data?.viewProposalSF?.locationDetails
                  ?.allIndiaBasisDesc,
              addressLine1:
                data?.viewProposalSF?.locationDetails
                  ?.address_line1,
              addressLine2:
                data?.viewProposalSF?.locationDetails
                  ?.address_line2,
              addressLine3:
                data?.viewProposalSF?.locationDetails
                  ?.address_line3,
              landmark:
                data?.viewProposalSF?.locationDetails?.land_mark,
              pincode:
                data?.viewProposalSF?.locationDetails?.pin_code,
              stateLocation:
                data?.viewProposalSF?.locationDetails?.state,
              loading: data?.viewProposalSF?.loadingPercent,
              discount: data?.viewProposalSF?.discountPercent,

              proposerDetailsMeta: {
                crn: reformData(customer?.cust_ref_number, ''),
                isNewCustomer: false,
                ifscCode: reformData(
                  customer?.bank_detail?.ifsc_code,
                  '',
                ),
                bankName: reformData(customer?.bank_detail?.name, ''),
                branchName: reformData(customer?.branch_name, ''),
                bankAcno: reformData(
                  customer?.bank_detail?.acc_number,
                  '',
                ),
                accountHolderName: reformData(
                  customer?.bank_detail?.acc_holder,
                  '',
                ),
                micrCode: reformData(
                  customer?.bank_detail?.micr_code,
                  '',
                ),
              },
              proposerDetails: {
                id: reformData(customer?.cust_number, ''),
                customerType: reformData(
                  customer?.cust_type?.code,
                  '',
                ),
                title: reformData(
                  customer?.indv_detail?.title?.code,
                  '',
                ),
                gender: reformData(
                  customer?.indv_detail?.gender?.code,
                  '',
                ),
                firstName: reformData(
                  customer?.indv_detail?.first_name,
                  '',
                ),
                middleName: reformData(
                  customer?.indv_detail?.middle_name,
                  '',
                ),
                lastName: reformData(
                  customer?.indv_detail?.surname,
                  '',
                ),
                fullName: reformData(
                  customer?.indv_detail?.full_name,
                  '',
                ),
                maritalStatus: reformData(
                  customer?.indv_detail?.marital_status?.code,
                  '',
                ),
                nationality: reformData(
                  customer?.indv_detail?.nationality?.code,
                  '',
                ),
                occupation: reformData(
                  customer?.indv_detail?.occupation?.code,
                  '',
                ),
                proposerDOB: reformData(
                  customer?.indv_detail?.date_of_birth,
                  '',
                ),
                panNumber: reformData(
                  getDomainData(
                    customerTypeList,
                    customer?.cust_type?.code,
                    'code',
                    'value',
                  )?.toLowerCase() === 'individual'         /**CR 498 */
                    ? customer?.indv_detail?.pan_card_number
                    : customer?.org_detail?.pan_card_number,
                  '',
                ),
                idProofType: reformData(
                  customer?.indv_detail?.id_proof_type?.code,
                  '',
                ),
                idProofNumber: reformData(
                  customer?.indv_detail?.id_proof_number,
                  '',
                ),
                permAddressLine1: reformData(
                  customer?.permanent_address?.address_line1,
                  '',
                ),
                permAddressLine2: reformData(
                  customer?.permanent_address?.address_line2,
                  '',
                ),
                permAddressLine3: reformData(
                  customer?.permanent_address?.address_line3,
                  '',
                ),
                permLandmark: reformData(
                  customer?.permanent_address?.land_mark,
                  '',
                ),
                permPincode: reformData(
                  customer?.permanent_address?.pin_code,
                  '',
                ),
                permCityTownVillage: reformData(
                  customer?.permanent_address?.city,
                  '',
                ),
                permDistrict: reformData(
                  customer?.permanent_address?.district,
                  '',
                ),
                permState: reformData(
                  customer?.permanent_address?.state,
                  '',
                ),
                permCommAddressYN: customer?.comm_equal_perm,
                commAddressLine1: reformData(
                  customer?.communication_address?.address_line1,
                  '',
                ),
                commAddressLine2: reformData(
                  customer?.communication_address?.address_line2,
                  '',
                ),
                commAddressLine3: reformData(
                  customer?.communication_address?.address_line3,
                  '',
                ),
                commLandmark: reformData(
                  customer?.communication_address?.land_mark,
                  '',
                ),
                commPincode: reformData(
                  customer?.communication_address?.pin_code,
                  '',
                ),
                commCityTownVillage: reformData(
                  customer?.communication_address?.city,
                  '',
                ),
                commDistrict: reformData(
                  customer?.communication_address?.district,
                  '',
                ),
                commState: reformData(
                  customer?.communication_address?.state,
                  '',
                ),
                mobileNo: reformData(customer?.contact?.mobile, ''),
                emailID: reformData(customer?.contact?.email),
                orgName: reformData(
                  customer?.org_detail?.org_name,
                  '',
                ),
                orgType: reformData(
                  customer?.org_detail?.org_type?.code,
                  '',
                ),
                contactName: reformData(
                  customer?.org_detail?.contact_name,
                  '',
                ),
                regNumber: reformData(
                  customer?.org_detail?.reg_number,
                  '',
                ),
                tanNumber: reformData(
                  customer?.org_detail?.tan_number,
                  '',
                ),
                gstNumber: reformData(
                  getDomainData(
                    customerTypeList,
                    customer?.cust_type?.code,
                    'code',
                    'value',
                  )?.toLowerCase() === 'individual'
                    ? customer?.indv_detail?.gst_number
                    : customer?.org_detail?.gst_number,
                  '',
                ),
                phoneNo: reformData(customer?.contact?.telephone, ''),
                altPhoneNo: reformData(
                  customer?.contact?.alt_telephone,
                  '',
                ),
                altMobileNo: reformData(
                  customer?.contact?.alt_mobile,
                  '',
                ),
                faxNo: reformData(customer?.contact?.fax_number, ''),
                employeeNumber: reformData(
                  customer?.indv_detail?.employeeNumber,
                  '',
                ),
              },

              reviewAndConfirmTabDetails: {
                proposalPaymentType:  (data?.viewProposalSF?.quoteNumber === 'NA' 
                    || data?.viewProposalSF?.quoteNumber === null )
                  ? 'EPROPOSAL'
                  : data?.viewProposalSF?.Proposal_Payment_Type?.toUpperCase(),
                isProposalCreated: data?.viewProposalSF
                  ?.proposalNumber
                  ? true
                  : false,
                documentDetails:
                  data?.viewProposalSF?.uploadedDocuments,
              },

              policy: {
                startDate: data?.viewProposalSF?.startDate,
                endDate: data?.viewProposalSF?.endDate,
                time: '',
              },

              issuedPolicyData: {
                policyNo: '',
                receiptID: [],
                referenceNumber: '',
                digiLink: '',
                displayMessage: '',
                additionalMessage: '',
              },

              premiumDetails: {
                termsAndConditions: false,
                paymentMethod: '',
                payerType: '',
                onlinePayment: {
                  transactionId: '',
                  isTransactionIdVerified: null,
                },
                cdWallet: {
                  cdAccountNo: '',
                  cdAccountBalance: '',
                },
                cheque: [],
                demandDraft: [],
              },
            });
          }
        } catch (error) {
          console.log('1126_error data',error)
        }
      }
    };
    fetchViewProposalData();
  }, [data, dataCustomerDetails, dataMyIntermediaries]);
  
return loadingCustomerDetails ||
    loadingDocumentExtensions ||
    loadingMyIntermediaries ||
    loading ? (
    <Loading />
  ) : errorCustomerDetails ||
    errorDocumentExtensions ||
    errorMyIntermediaries ||
    error ? (
    <Error
      error={
        errorCustomerDetails ||
        errorDocumentExtensions ||
        errorMyIntermediaries ||
        error
      }
    />
  ) : customerID?.toString()?.toLowerCase() ===
      data?.viewProposalSF?.customerID?.toString()?.toLowerCase() &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewProposalSF?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <NewFirePolicyIssuanceSA
      startStep={3}
      isProposalNumberGenerated={true}
      customerID={customerID}
      lobCode={lobCode}
      lobName={lobName}
      productName={productName}
      productCode={productCode}
      proposalNumber={proposalNumber}
      stepsDisabled={[true, true, true, false, false]}
      breadcrumbNav={['Quote', 'View Proposal', 'Buy Policy']}
    />
  ) : customerID?.toString()?.toLowerCase() !==
    data?.viewProposalSF?.customerID?.toString()?.toLowerCase() ? (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Incorrect Customer ID for the given Proposal Number.
        </Text>
      </Card>
    </Layout>
  ) : (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view proposal belonging
          to another intermediary.
        </Text>
      </Card>
    </Layout>
  );
}
